import { Input } from "./Input";

export const Notes = ({ name, ...props }) => {
  return <Input sku={name} as="textarea" rows={4} {...props} />;
};
